import {stringToDashed} from 'cl-automation-utils';
import React, {Component} from 'react';
import Dialog from 'material-ui/Dialog';
import RaisedButton from 'material-ui/RaisedButton';
import IconButton from 'material-ui/IconButton';
import FontIcon from 'material-ui/FontIcon';
import styles from './ChangePlanDialogStyles';
import _ from 'lodash';
import InlineNotification from 'crazyEditor/components/EditorUI/BaseUI/InlineMessages/InlineNotification';
import {changeBillingPeriod, changePlan} from 'MyAccount/ViewDesigns/helpers/preferencesHelper';
import {
  CHANGE_TYPE_BILLING_PERIOD,
  CHANGE_PLAN_DIALOG_NAME,
  BILLING_PERIOD,
  PAYMENT_SUCCESS_TYPE,
  CHANGE_TYPE_PLAN,
  NEW_PLANS_GENERATION,
} from './Consts';
import {updateUserData} from 'MyAccount/ViewDesigns/redux/modules/user';
import * as Colors from 'material-ui/styles/colors';
import InfoDialog from 'shared/components/Dialogs/InfoDialog/InfoDialog';
import {minusCircle, warning} from 'shared/icons';
import InlineButton from 'shared/components/InlineButton';
import {contactSupportWithMessage} from 'shared/helpers/analyticsHelper';
import LinearProgress from 'material-ui/LinearProgress';
const piggyBank = require('./images/piggyBank.svg');
const piggyBankBroken = require('./images/piggyBankBroken.svg');
import {RadioButton, RadioButtonGroup} from 'material-ui/RadioButton';
import PropTypes from 'prop-types';
import Radium from 'radium';
import connectWithRouter from 'shared/components/redux/connectWithRouter';
import {PlanAndBilling} from 'MyAccount/AccountPage/AccountPageSectionsData';

const STARTER_PLAN_IMAGE = 1;
const GROWING_PLAN_IMAGE = 2;
const CUSTOM_PLAN_IMAGE = 3;

const planImages = [
  require('./images/lite.svg'),
  require('./images/basic.svg'),
  require('./images/pro.svg'),
  require('./images/enterprise.svg'),
];

const arrow = require('./images/arrow.svg');

@connectWithRouter(
  state => {
    const toPlanId = parseInt(state.routing.location.query.toPlanId, 10);
    return {
      plans: state.user.plans,
      userPlan: state.user.userPlan,
      billingPeriod: state.user.billingPeriod,
      billingPeriodString: state.user.billingPeriodString,
      switchToAnnualSave: state.user.switchToAnnualSave,
      eBayAccountsCount: state.accountPage.accounts ? _.size(state.accountPage.accounts) : 0,
      eBayAccountsLimit: state.user.userPlan.eBayAccountsLimit,
      activeListingsLimit: state.user.userPlan.activeListingsLimit,
      activeListingsCount: state.user.activeListingsCount,
      paymentDue: state.user.paymentDue,
      switchToAnnualChargeAmount: state.user.switchToAnnualChargeAmount,
      open: state.routing.location.query.openDialog === CHANGE_PLAN_DIALOG_NAME,
      query: state.routing.location.query,
      changeType: state.routing.location.query.changeType,
      toPlanId: toPlanId,
      toBillingPeriod: parseInt(state.routing.location.query.toBillingPeriod, 10),
      pathname: state.routing.location.pathname,
      nextScheduledPayment: new Date(1000 * parseInt(state.user.nextScheduledPayment, 10)).toLocaleDateString(),
      toPlan: _.find(state.user.plans, {id: toPlanId}),
      planLocked: state.user.planLocked,
      isVip: state.user.isVip,
      userCredit: state.user.referrals.userCredit,
      refundAmount: state.user.refundAmount,
      pricingGeneration: state.user.pricingGeneration,
    };
  },
  {updateUserData}
)
@Radium
export default class ChangePlanDialog extends Component {
  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  state = {
    statusMessage: null,
    error: false,
    selectedBillingPeriod: BILLING_PERIOD.YEAR,
  };

  componentWillReceiveProps(nextProps) {
    if (!this.props.open && nextProps.open) {
      this.setState({statusMessage: null, error: false, selectedBillingPeriod: BILLING_PERIOD.YEAR});
    }
  }

  getImage() {
    const {toPlanId, changeType, toBillingPeriod, pricingGeneration} = this.props;
    if (changeType === CHANGE_TYPE_BILLING_PERIOD) {
      if (toBillingPeriod === BILLING_PERIOD.YEAR) {
        return piggyBank;
      }
      return piggyBankBroken;
    }
    let {plans} = this.props;
    const plan = _.find(plans, plan => plan.id === toPlanId);
    if (plan && plan.legacy) {
      return planImages[CUSTOM_PLAN_IMAGE];
    }
    if (pricingGeneration === NEW_PLANS_GENERATION) {
      if (plan && plan.isPreferred) {
        return planImages[GROWING_PLAN_IMAGE];
      }
      return planImages[STARTER_PLAN_IMAGE];
    }
    plans = _.filter(plans, plan => !plan.legacy);
    plans = plans.sort((plan1, plan2) => {
      return parseInt(plan1.price, 10) - parseInt(plan2.price, 10);
    });
    return planImages[_.findIndex(plans, plan => plan.id === toPlanId)];
  }

  getErrorDialog() {
    const {
      paymentDue,
      toPlan,
      eBayAccountsCount,
      activeListingsCount,
      planLocked,
      userPlan,
      toBillingPeriod,
      open,
    } = this.props;
    if (!open) {
      return null;
    }

    const tooManyAccounts = toPlan && toPlan.eBayAccountsLimit && toPlan.eBayAccountsLimit < eBayAccountsCount;
    const tooManyActiveListings =
      toPlan && toPlan.activeListingsLimit && toPlan.activeListingsLimit < activeListingsCount;

    if (
      paymentDue ||
      (planLocked &&
        (toBillingPeriod === BILLING_PERIOD.YEAR ||
          (toPlan && parseInt(toPlan.price, 10) > parseInt(userPlan.price, 10))))
    ) {
      return this.getContactSupportErrorDialog();
    }
    if (tooManyAccounts || tooManyActiveListings) {
      return (
        <InfoDialog
          open
          level="error"
          setOpen={() => this.closeDialog()}
          title="Downgrade Plan Failed"
          message={
            <div>
              <div style={{fontWeight: 300, fontSize: 24, marginBottom: 5}}>
                It is not possible to downgrade your plan to {toPlan.name}
              </div>
              <div style={{marginBottom: 35}}>
                In order to downgrade the plan please resolve the following{' '}
                {tooManyActiveListings && tooManyAccounts ? 'issues' : 'issue'}:
              </div>
              {tooManyAccounts && (
                <InlineNotification style={{height: 60, width: 820}} level="error" iconPath={minusCircle}>
                  You have {eBayAccountsCount} ebay accounts connected while your new plan allows only{' '}
                  {toPlan.eBayAccountsLimit}.
                </InlineNotification>
              )}
              {tooManyActiveListings && (
                <InlineNotification style={{height: 60, width: 820}} level="error" iconPath={minusCircle}>
                  You have {activeListingsCount} live managed listings while your new plan allows only{' '}
                  {toPlan.activeListingsLimit}.
                </InlineNotification>
              )}
            </div>
          }
        />
      );
    }
    return null;
  }

  getContactSupportErrorDialog() {
    const contactSupport = () =>
      contactSupportWithMessage('I want to change plan but "It is not possible to change plan at this point"');
    return (
      <InfoDialog
        open
        level="error"
        setOpen={() => this.closeDialog()}
        title="Changing Plan Failed"
        cancelButtonLabel="cancel"
        buttonLabel="contact support"
        action={contactSupport}
        message={
          <div>
            <div style={{fontWeight: 300, fontSize: 24, marginBottom: 5}}>
              It is not possible to change plan at this point
            </div>
            <div style={{marginBottom: 35}}>
              Please{' '}
              <InlineButton
                onClick={() => {
                  this.closeDialog();
                  contactSupport();
                }}
              >
                contact support
              </InlineButton>{' '}
              for further assistance
            </div>
          </div>
        }
      />
    );
  }

  handleChangeSelectedBillingPeriod = (event, selectedBillingPeriod) => {
    this.setState({selectedBillingPeriod});
  };

  handleOk = () => {
    const {toPlan, changeType, updateUserData, userPlan, toPlanId, toBillingPeriod, isVip} = this.props;
    const {selectedBillingPeriod} = this.state;
    const showErrorDialog = (error = 'Unknown Error') => {
      this.setState({error: true}); // close the main dialog
      const contactSupport = () => {
        contactSupportWithMessage(`I got this error message while trying to resolve a payment issue: ${error}`);
        this.closeDialog();
      };
      InfoDialog.info({
        level: 'error',
        message: (
          <div>
            <div style={{fontWeight: 300, fontSize: 24, marginBottom: 5}}>
              We ran into some trouble processing your payment.
            </div>
            <div style={{marginBottom: 35}}>This is the error we get:</div>
            <InlineNotification style={{height: 60, width: 820, marginBottom: 20}} level="error" iconPath={warning}>
              {error}
            </InlineNotification>
            We encourage you to contact PayPal for more information.
            <br />
            Let’s get you back on track, once ready: <InlineButton onClick={this.handleOk}>retry payment.</InlineButton>
            <br />
            Still have questions? <InlineButton onClick={contactSupport}>contact support.</InlineButton>
          </div>
        ),
        title: 'Changing Plan Failed',
        buttonLabel: 'retry payment',
        cancelButtonLabel: 'contact support',
        action: this.handleOk,
        secondaryAction: contactSupport,
        onClose: this.closeDialog(),
      });
    };
    if (changeType === CHANGE_TYPE_BILLING_PERIOD) {
      changeBillingPeriod(toBillingPeriod).then(response => {
        if (response.success) {
          updateUserData(response.user);
          this.closeDialog({paymentSuccessType: PAYMENT_SUCCESS_TYPE.BILLING_PERIOD}, true);
        } else {
          showErrorDialog(response.message);
        }
      });
      if (toBillingPeriod === BILLING_PERIOD.YEAR) {
        this.setState({statusMessage: 'processing payment'});
      } else {
        this.setState({statusMessage: 'updating billing cycle'});
      }
    } else {
      const isUpgrade = parseInt(toPlan.price, 10) > parseInt(userPlan.price, 10);
      changePlan(toPlanId, selectedBillingPeriod).then(response => {
        if (response.success) {
          updateUserData(response.user);
          const topPlanQueryAddition = isVip ? {topPlan: true} : {};
          this.closeDialog({paymentSuccessType: PAYMENT_SUCCESS_TYPE.PLAN, ...topPlanQueryAddition}, true);
        } else {
          showErrorDialog(response.message);
        }
      });
      if (isUpgrade) {
        this.setState({statusMessage: 'processing payment'});
      } else {
        this.setState({statusMessage: 'updating your plan'});
      }
    }
  };

  closeDialog = (queryProps = {}, backToPlanAndBilling = false) => {
    const {query, pathname} = this.props;
    this.context.router.replace({
      pathname: backToPlanAndBilling ? PlanAndBilling.route : pathname,
      query: {..._.omit(query, ['openDialog', 'changeType', 'toPlanId', 'toBillingPeriod']), ...queryProps},
    });
  };

  render() {
    const errorDialog = this.getErrorDialog();
    if (errorDialog) {
      return errorDialog;
    }
    const {
      billingPeriod,
      toPlan,
      switchToAnnualChargeAmount,
      userPlan,
      changeType,
      switchToAnnualSave,
      nextScheduledPayment,
      userCredit,
      refundAmount,
    } = this.props;
    let {open, toBillingPeriod} = this.props;
    const {statusMessage, error, selectedBillingPeriod} = this.state;
    toBillingPeriod = selectedBillingPeriod || toBillingPeriod || billingPeriod;
    if (error) {
      open = false;
    }
    let h1;
    let h2;
    let h3;
    let buttonLabel;
    let newPrice;
    let chargeAmount;
    let billingPeriodSelect;
    const totalBalance = Math.floor(userCredit + refundAmount);

    let chargeMessage;
    if (open) {
      if (changeType === CHANGE_TYPE_BILLING_PERIOD) {
        h2 = `You are about to update the billing cycle of the ${userPlan.name} plan and`;
        buttonLabel = 'update billing cycle';
        if (toBillingPeriod === BILLING_PERIOD.YEAR) {
          h1 = `Save $${switchToAnnualSave} With Annual Billing`;
          newPrice = parseInt(userPlan.annualPrice, 10) * 12;
          h3 = `$${newPrice.toFixed(2)}/Year`;
          chargeAmount = switchToAnnualChargeAmount;
        } else if (toBillingPeriod === BILLING_PERIOD.MONTH) {
          h1 = (
            <span>
              Pay{' '}
              <span style={{color: Colors.red800}}>
                ${(parseInt(userPlan.price, 10) - parseInt(userPlan.annualPrice, 10)).toFixed(2)} More
              </span>{' '}
              each month
            </span>
          );
          chargeMessage = (
            <span>
              You’ll be charged <strong>${userPlan.price}/Mo</strong> beginning {nextScheduledPayment}
            </span>
          );
        }
      } else {
        if (toBillingPeriod === BILLING_PERIOD.MONTH) {
          h3 = `$${toPlan.price}/Month`;
        } else {
          h3 = `$${toPlan.annualPrice}/Month paid annually`;
        }
        h1 = `${toPlan.name} Plan`;
        if (parseInt(toPlan.price, 10) > parseInt(userPlan.price, 10)) {
          buttonLabel = `Upgrade to ${toPlan.name} Plan`;
          h2 = 'You are about to upgrade to the';
          if (billingPeriod === BILLING_PERIOD.MONTH) {
            if (selectedBillingPeriod === BILLING_PERIOD.YEAR) {
              chargeAmount = toPlan.changeToAnnualChargeAmount;
            } else {
              chargeAmount = toPlan.changeToChargeAmount;
            }
          } else {
            chargeAmount = toPlan.changeToChargeAmount;
          }
        } else if (parseInt(toPlan.price, 10) <= parseInt(userPlan.price, 10)) {
          if (parseInt(toPlan.price, 10) === parseInt(userPlan.price, 10)) {
            buttonLabel = `change to ${toPlan.name} Plan`;
            h2 = 'You are about to change to the';
          } else {
            buttonLabel = `downgrade to ${toPlan.name} Plan`;
            h2 = 'You are about to downgrade to the';
          }
          if (toBillingPeriod === BILLING_PERIOD.MONTH) {
            chargeMessage = (
              <span style={{textAlign: 'right'}}>
                You’ll be charged <strong>${toPlan.price}/Month</strong> beginning {nextScheduledPayment}
              </span>
            );
          } else {
            chargeMessage = (
              <span style={{textAlign: 'right'}}>
                You’ll be charged <strong>${toPlan.annualPrice}/Month paid annually</strong> beginning{' '}
                {nextScheduledPayment}
              </span>
            );
          }
        }
        billingPeriodSelect = billingPeriod === BILLING_PERIOD.MONTH && (
          <div style={{textAlign: 'left', width: 450, display: 'flex', marginTop: 10, position: 'relative'}}>
            <div
              style={{
                fontWeight: 600,
                backgroundRepeat: 'no-repeat',
                color: Colors.white,
                height: 35,
                width: 130,
                position: 'absolute',
                left: -145,
                top: -6,
                backgroundImage: `url(${arrow})`,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundSize: 'cover',
                backgroundPosition: 'contain',
              }}
            >
              SAVE ${toPlan.switchToAnnualSave}
            </div>
            <RadioButtonGroup
              style={{flexGrow: 1}}
              valueSelected={selectedBillingPeriod}
              onChange={this.handleChangeSelectedBillingPeriod}
            >
              <RadioButton
                id="cla-radio-annual-billing"
                value={BILLING_PERIOD.YEAR}
                label={
                  <span>
                    <strong>Annual Subscription</strong> ${parseInt(toPlan.annualPrice, 10)} x 12 months
                  </span>
                }
                labelStyle={{color: Colors.grey700, fontSize: 20}}
              />
              <RadioButton
                id="cla-radio-monthly-billing"
                style={{marginTop: 5}}
                value={BILLING_PERIOD.MONTH}
                label={
                  <span>
                    <strong>Monthly Subscription</strong> ${parseInt(toPlan.price, 10)} month to month
                  </span>
                }
                labelStyle={{color: Colors.grey700, fontSize: 20}}
              />
            </RadioButtonGroup>
          </div>
        );
      }
    }

    if (chargeAmount < 0) {
      return this.getContactSupportErrorDialog();
    }

    if (!chargeMessage) {
      chargeMessage = chargeAmount ? (
        <span>
          Your current account balance is US ${totalBalance}
          <br />
          You'll be immediately charged an additional <strong>US ${chargeAmount}</strong>
        </span>
      ) : (
        <span>
          You’ll be charged <strong>${userPlan.price}/Mo</strong> beginning {nextScheduledPayment}
        </span>
      );
    }

    return (
      <Dialog bodyStyle={styles.dialogBody} contentStyle={styles.dialogContent} open={open}>
        <div style={styles.content}>
          <div style={{textAlign: 'center'}}>
            <div style={{fontSize: 16}}>{h2}</div>
            <div style={{fontSize: 40}}>{h1}</div>
            {billingPeriodSelect ? billingPeriodSelect : <div style={{fontSize: 20}}>{h3}</div>}
          </div>
          <div style={styles.imageContainer}>
            <img style={styles.image} src={this.getImage()} />
          </div>
          <InlineNotification
            style={{height: 70, minWidth: 400, textAlign: 'center', lineHeight: '125%'}}
            animate={!!billingPeriodSelect}
            easyTransitionPath={selectedBillingPeriod}
          >
            {chargeMessage}
          </InlineNotification>
          <RaisedButton
            id={`cla-btn-${stringToDashed(statusMessage || buttonLabel)}`}
            disabled={!!statusMessage}
            primary
            style={styles.button}
            label={statusMessage || buttonLabel}
            onClick={this.handleOk}
          >
            {statusMessage && (
              <LinearProgress
                mode="indeterminate"
                style={{position: 'absolute', bottom: 0, left: 0, width: '100%', backgroundColor: 'none'}}
              />
            )}
          </RaisedButton>
        </div>
        <IconButton
          id="cla-btn-x"
          onClick={() => this.closeDialog()}
          iconStyle={styles.closeIcon}
          style={styles.closeIcon}
        >
          <FontIcon className="material-icons">close</FontIcon>
        </IconButton>
      </Dialog>
    );
  }
}

ChangePlanDialog.propTypes = {
  changeType: PropTypes.oneOf([CHANGE_TYPE_BILLING_PERIOD, CHANGE_TYPE_PLAN]),
};
